import React from "react";

import { useIntl } from "react-intl";

import { Alert } from "@mapmycustomers/ui";

import styles from "./InfoAlert.module.scss";
import messages from "./messages";

const InfoAlert = () => {
  const intl = useIntl();

  return (
    <Alert
      className={styles.container}
      message={intl.formatMessage(messages.infoMessage)}
      showIcon
    />
  );
};

export default InfoAlert;
